<template>
  <div class="EditContainer mb20">
    <div class="w200 mb20">
      <div class="mb4"><span class="red">*</span>状态：</div>
      <a-radio-group
        :options="[
          { value: 1, label: '启用' },
          { value: 0, label: '禁用' }
        ]"
        v-model:value="footerPolicyParams.status"
        :disabled="notDefaultLang"
      />
    </div>
    <div class="w200 mb20">
      <div class="mb4"><span class="red">*</span>不展示的路由：</div>
      <a-input
        :disabled="notDefaultLang"
        class="w300"
        v-model:value="footerPolicyParams.filterUrl"
        placeholder="多个路由以;分割"
      />
    </div>
  </div>
  <div class="EditContainer df">
    <div>
      <draggable
        class="wrapper df"
        style="flex-wrap: wrap;"
        v-model="footerPolicyItemDTOList"
        @start="drag = true"
        @end="drag = false"
        item-key="index"
        :filter="'.undraggable'"
      >
        <template #item="{ element, index }">
          <div>
            <div
              class="element"
              v-if="
                element.addButton &&
                  footerPolicyItemDTOList.filter(v => !v.addButton).length < 4
              "
            >
              <div class="addTopBarItem" @click.stop="addTopBarItem">
                + 添加
              </div>
            </div>
            <div class="element" v-if="!element.addButton">
              <div class="subscription">
                <div class="title oh pr df">
                  <div style="margin-top: -2px; cursor: pointer;">
                    <img :src="dragIcon" style="height: 20px;" />
                  </div>
                  <b>政策条款{{ index + 1 }}</b>
                  <a-popconfirm
                    title="是否确定删除?"
                    ok-text="确定"
                    cancel-text="取消"
                    @confirm="() => removeTopbar(index)"
                    @cancel="() => {}"
                  >
                    <div
                      class="pa t2 r0 cp"
                      v-if="!element.addButton && index !== 0"
                    >
                      <delete-outlined />
                    </div>
                  </a-popconfirm>
                </div>
                <div>
                  <div class="mb20">
                    <div class="mb4 undraggable">
                      <span class="red">*</span>文案：<span class="red"
                        >（政策条款禁止换行）</span
                      >
                    </div>
                    <div style="background: #ffffff;" class="pr">
                      <a-textarea
                        v-model:value="
                          element.langs[
                            element.langs.findIndex(
                              v => v.langCode === langCode
                            )
                          ].title
                        "
                        placeholder="请输入"
                      />
                    </div>
                  </div>
                  <div class="mb20">
                    <div class="mb4 undraggable">
                      <a-radio-group
                        v-model:value="element.itemType"
                        :disabled="notDefaultLang"
                      >
                        <a-radio :value="1">链接</a-radio>
                        <a-radio :value="2">订阅弹窗</a-radio>
                        <a-radio :value="3">注册弹窗</a-radio>
                      </a-radio-group>
                    </div>
                    <div
                      style="background: #ffffff;"
                      class="pr"
                      v-if="element.itemType === 1"
                    >
                      <a-input
                        :disabled="notDefaultLang"
                        v-model:value="element.link"
                        placeholder="请输入"
                      />
                    </div>
                  </div>
                  <div class="mb20 ">
                    <div class="mb4"><span class="red">*</span>图片Icon：</div>
                    <div>
                      <div>
                        <div class="w80 h80 mb10 pr">
                          <a-upload-dragger
                            :fileList="[]"
                            :show-upload-list="false"
                            name="file"
                            :multiple="true"
                            :customRequest="e => upload(e, index)"
                            :accept="'.png,.jpg,.jpeg,.gif'"
                            :headers="uploadHeaders"
                          >
                            <div v-if="['', null].includes(getImgUrl(element))">
                              <div
                                class="w80 h80 tac"
                                style="color: #999999; font-size: 40px; line-height: 80px;"
                              >
                                <PictureOutlined />
                              </div>
                            </div>
                          </a-upload-dragger>
                          <div
                            v-if="!['', null].includes(getImgUrl(element))"
                            class="h80 pa l0 t0 sidebarContentBg"
                            :style="
                              `width: 80px; background: url('${getImgUrl(
                                element
                              )}') center center/ cover no-repeat;`
                            "
                          >
                            <div class="hover">
                              <EyeOutlined
                                @click="
                                  () =>
                                    changeVisiblePic(true, getImgUrl(element))
                                "
                              />
                              &nbsp;&nbsp;
                              <DeleteOutlined
                                @click="getImgUrl(element, true)"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="ml16">44 * 44</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </draggable>
    </div>
  </div>
</template>
<script>
import { toRefs, reactive, inject, computed } from 'vue'
import draggable from 'vuedraggable'
import {
  EyeOutlined,
  PictureOutlined,
  DeleteOutlined
} from '@ant-design/icons-vue'
export default {
  components: {
    draggable,
    DeleteOutlined,
    EyeOutlined,
    PictureOutlined
  },
  setup() {
    const injectState = inject('initState')
    const notDefaultLang = computed(
      () => injectState.langCode !== injectState.defaultLanguageCode
    )
    const state = reactive({
      changeDate: (dateString, item) => {
        console.log('dateString ', dateString)
        item.startTime = dateString[0]
        item.endTime = dateString[1]
      },
      countChange: (e, element) => {
        if (!e.target.checked) {
          element.times = []
          element.startTime = null
          element.endTime = null
        }
      }
    })
    return {
      ...toRefs(injectState),
      ...toRefs(state),
      notDefaultLang,
      editorOption: {
        placeholder: '输入',
        modules: {
          toolbar: [
            [
              {
                font: [
                  'Muli-Light',
                  'Muli-SemiBold',
                  'Muli-Bold',
                  'Muli-ExtraBold'
                ]
              }
            ],
            [{ size: ['small', false, 'large', 'huge', '12px'] }],
            ['bold', 'link'],
            [
              {
                color: [
                  'red',
                  'blue',
                  'green',
                  'black',
                  'yellow',
                  'pink',
                  'white',
                  '#14AA6E'
                ]
              }
            ]
          ]
        }
      },
      statusOptions: [
        {
          label: '禁用',
          value: 0
        },
        {
          label: '启用',
          value: 1
        }
      ],
      ceilingOptions: [
        {
          label: '是',
          value: true
        },
        {
          label: '否',
          value: false
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
.editBread {
  background: #ffffff;
  margin: 15px;
  padding: 15px 20px;
}
.EditContainer {
  background: #ffffff;
  margin: 15px;
  padding: 15px 20px;
}

.checkTabs {
  width: 216px;
  height: 46px;
  background: #f0f0f0;
  display: flex;
  padding: 3px;
  border-radius: 3px;
}

.checkTab {
  width: 108px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  border-radius: 3px;
  cursor: pointer;
}

.checkTab.check {
  background: #ffffff;
}

.checkPicTabs {
  width: 146px;
  height: 36px;
  background: #f0f0f0;
  display: flex;
  padding: 3px;
  border-radius: 3px;
  margin: 0 auto 20px auto;
}

.checkPicTab {
  width: 70px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  border-radius: 3px;
  cursor: pointer;
}

.checkPicTab.check {
  background: #ffffff;
}

.EditContainerRight {
  background: #f4f4f4;
  width: 400px;
  padding: 14px;
  margin: 14px;
}

.colorBlock {
  width: 50px;
  height: 24px;
  margin-right: 10px;
  display: block;
  float: left;
  margin-top: 4px;
}

.addTopBarItem {
  cursor: pointer;
}
.element {
  width: 300px;
  height: 510px;
  background: #f8f8f8;
  margin: 10px;
  padding: 10px;
}

.element .title {
  height: 40px;
  line-height: 40px;
  font-size: 16px;
}

.addTopBarItem {
  width: 300px;
  height: 510px;
  text-align: center;
  line-height: 510px;
}

.sidebarContentBg .hover {
  width: 80px;
  height: 80px;
  display: none;
  cursor: pointer;
  color: #ffffff;
  text-align: center;
  line-height: 80px;
  background: rgba(0, 0, 0, 0.3);
}

.sidebarContentBg:hover .hover {
  display: block;
}
</style>
<style>
.subscription .ant-upload.ant-upload-drag .ant-upload {
  padding: 0;
}
</style>
<style>
.colorPickerPer .vc-lightness-slider,
.colorPickerPer .vc-display {
  display: none !important;
}
</style>
<style>
.subscription .ant-upload.ant-upload-drag .ant-upload {
  padding: 0;
}
</style>
